// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos personalizados para TiposList */

.tipos-container {
  padding: 20px;
}

.tipos-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 30px;
  border-radius: 10px;
  margin-bottom: 30px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.tipos-header h2 {
  margin: 0;
  font-weight: 600;
  font-size: 2.2rem;
}

.tipos-header p {
  margin: 10px 0 0 0;
  opacity: 0.9;
  font-size: 1.1rem;
}

.search-container {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
}

.category-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.category-button {
  border-radius: 25px;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s ease;
  border: 2px solid;
  min-width: 140px;
  justify-content: center;
}

.category-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.category-button.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-color: #667eea;
  color: white;
}

.category-button:not(.active) {
  background: white;
  border-color: #e9ecef;
  color: #6c757d;
}

.category-button:not(.active):hover {
  border-color: #667eea;
  color: #667eea;
}

.tipos-table {
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.tipos-table .table {
  margin: 0;
}

.tipos-table .table thead th {
  background: #f8f9fa;
  border: none;
  font-weight: 600;
  color: #495057;
  padding: 15px;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.tipos-table .table tbody td {
  padding: 15px;
  vertical-align: middle;
  border-top: 1px solid #f1f3f4;
}

.tipos-table .table tbody tr:hover {
  background-color: #f8f9fa;
  transition: background-color 0.2s ease;
}

.action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.action-buttons .btn {
  min-width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.action-buttons .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.status-badge {
  font-size: 0.8rem;
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: 500;
}

.status-badge.bg-success {
  background-color: #28a745 !important;
}

.status-badge.bg-secondary {
  background-color: #6c757d !important;
}

.create-button {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(40, 167, 69, 0.3);
}

.create-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(40, 167, 69, 0.4);
  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);
}

.modal-content {
  border-radius: 15px;
  border: none;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.modal-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 15px 15px 0 0;
  border: none;
}

.modal-header .btn-close {
  filter: invert(1);
}

.modal-title {
  font-weight: 600;
}

.form-label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
}

.form-control {
  border-radius: 8px;
  border: 2px solid #e9ecef;
  padding: 12px 16px;
  transition: all 0.2s ease;
}

.form-control:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
}

.form-switch {
  padding-left: 2.5em;
}

.form-switch .form-check-input {
  width: 3em;
  height: 1.5em;
  margin-left: -2.5em;
  background-color: #e9ecef;
  border: none;
  border-radius: 1em;
}

.form-switch .form-check-input:checked {
  background-color: #28a745;
}

.form-switch .form-check-input:focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.modal-footer {
  border-top: 1px solid #e9ecef;
  padding: 20px;
}

.modal-footer .btn {
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 600;
}

.delete-alert {
  border-radius: 10px;
  border: none;
}

.delete-alert .alert-warning {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #6c757d;
}

.empty-state .empty-icon {
  font-size: 3rem;
  margin-bottom: 20px;
  opacity: 0.5;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
}

.loading-spinner .spinner-border {
  width: 3rem;
  height: 3rem;
  color: #667eea;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .tipos-header {
    padding: 20px;
    text-align: center;
  }

  .tipos-header h2 {
    font-size: 1.8rem;
  }

  .category-buttons {
    flex-direction: column;
    gap: 8px;
  }

  .category-button {
    min-width: 100%;
    justify-content: center;
  }

  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }

  .action-buttons .btn {
    min-width: 32px;
    height: 32px;
  }

  .tipos-table .table thead th,
  .tipos-table .table tbody td {
    padding: 10px 8px;
    font-size: 0.85rem;
  }
}

/* Animaciones */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.tipos-container {
  animation: fadeIn 0.5s ease-out;
}

.tipos-table {
  animation: fadeIn 0.6s ease-out;
}

/* Estilos para el estado vacío */
.empty-state-container {
  background: white;
  border-radius: 10px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.empty-state-container .empty-icon {
  font-size: 4rem;
  color: #dee2e6;
  margin-bottom: 20px;
}

.empty-state-container h4 {
  color: #6c757d;
  margin-bottom: 10px;
}

.empty-state-container p {
  color: #adb5bd;
  margin-bottom: 20px;
}

/* Estilos para el texto "Activo" en el modal de edición */
.modal .form-check label {
  padding-left: 20px !important;
  padding-top: 3px !important;
}

/* Estilos para el contenedor de búsqueda integrado */
.search-input-container {
  width: 100%;
  /* Occupies full width */
  padding-top: 20px;
  /* Added padding top for spacing */
}

.search-input-container .input-group {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  /* The input group also occupies full width */
}

.search-input-container .form-control {
  border-radius: 0 8px 8px 0;
  border-left: none;
}

.search-input-container .input-group-text {
  background: white;
  border-right: none;
  border-radius: 8px 0 0 8px;
  color: #6c757d;
}

/* Estilos para la columna de acciones */
.tipos-table th:last-child,
.tipos-table td:last-child {
  width: 80px;
  /* Reducir el ancho de la columna de acciones */
  min-width: 80px;
  /* Ancho mínimo para evitar que se comprima demasiado */
  max-width: 80px;
  /* Ancho máximo para mantener consistencia */
  text-align: center;
  /* Centrar el contenido de la columna */
}

/* Ajustar el ancho de las otras columnas */
.tipos-table th:first-child,
.tipos-table td:first-child {
  width: 60%;
  /* La columna de nombre ocupa más espacio */
}

.tipos-table th:nth-child(2),
.tipos-table td:nth-child(2) {
  width: 30%;
  /* La columna de estado ocupa menos espacio */
}

/* Estilos específicos por clase para mayor control */
.tipos-data-table .nombre-column {
  width: 60%;
  min-width: 200px;
}

.tipos-data-table .estado-column {
  width: 30%;
  min-width: 120px;
}

.tipos-data-table .acciones-column {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  text-align: center;
}

/* Asegurar que los botones de acción no se desborden */
.tipos-data-table .action-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}

.tipos-data-table .action-buttons .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

/* Ajustes aislados para la categoría "Documentos":
   se desactivan anchos rígidos y se compacta la tabla para evitar scroll horizontal. */
.tipos-data-table-documentos .nombre-column,
.tipos-data-table-documentos .estado-column,
.tipos-data-table-documentos .acciones-column,
.tipos-data-table-documentos th,
.tipos-data-table-documentos td {
  width: auto !important;
  min-width: 0 !important;
  max-width: none !important;
}

.tipos-data-table-documentos thead th,
.tipos-data-table-documentos tbody td {
  padding: 10px 8px;
}

.tipos-data-table-documentos .nombre-column,
.tipos-data-table-documentos td:first-child {
  white-space: normal;
}

/* Estilos para el modal */
.modal .form-check label {
  padding-left: 20px !important;
  padding-top: 3px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/TiposList.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;EACE,aAAa;AACf;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,gBAAgB;AAChB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,0DAA0D;AAC1D;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,qDAAqD;AACrD;EACE,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,wCAAwC;AACxC;;EAEE,WAAW;EACX,+CAA+C;EAC/C,eAAe;EACf,uDAAuD;EACvD,eAAe;EACf,4CAA4C;EAC5C,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,2CAA2C;AAC3C;;EAEE,UAAU;EACV,2CAA2C;AAC7C;;AAEA;;EAEE,UAAU;EACV,6CAA6C;AAC/C;;AAEA,qDAAqD;AACrD;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;uFACuF;AACvF;;;;;EAKE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B","sourcesContent":["/* Estilos personalizados para TiposList */\r\n\r\n.tipos-container {\r\n  padding: 20px;\r\n}\r\n\r\n.tipos-header {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  padding: 30px;\r\n  border-radius: 10px;\r\n  margin-bottom: 30px;\r\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.tipos-header h2 {\r\n  margin: 0;\r\n  font-weight: 600;\r\n  font-size: 2.2rem;\r\n}\r\n\r\n.tipos-header p {\r\n  margin: 10px 0 0 0;\r\n  opacity: 0.9;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.search-container {\r\n  background: white;\r\n  padding: 20px;\r\n  border-radius: 10px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.category-buttons {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n}\r\n\r\n.category-button {\r\n  border-radius: 25px;\r\n  padding: 8px 16px;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  transition: all 0.3s ease;\r\n  border: 2px solid;\r\n  min-width: 140px;\r\n  justify-content: center;\r\n}\r\n\r\n.category-button:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.category-button.active {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  border-color: #667eea;\r\n  color: white;\r\n}\r\n\r\n.category-button:not(.active) {\r\n  background: white;\r\n  border-color: #e9ecef;\r\n  color: #6c757d;\r\n}\r\n\r\n.category-button:not(.active):hover {\r\n  border-color: #667eea;\r\n  color: #667eea;\r\n}\r\n\r\n.tipos-table {\r\n  background: white;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.tipos-table .table {\r\n  margin: 0;\r\n}\r\n\r\n.tipos-table .table thead th {\r\n  background: #f8f9fa;\r\n  border: none;\r\n  font-weight: 600;\r\n  color: #495057;\r\n  padding: 15px;\r\n  font-size: 0.9rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.tipos-table .table tbody td {\r\n  padding: 15px;\r\n  vertical-align: middle;\r\n  border-top: 1px solid #f1f3f4;\r\n}\r\n\r\n.tipos-table .table tbody tr:hover {\r\n  background-color: #f8f9fa;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.action-buttons {\r\n  display: flex;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.action-buttons .btn {\r\n  min-width: 36px;\r\n  height: 36px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 6px;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.action-buttons .btn:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.status-badge {\r\n  font-size: 0.8rem;\r\n  padding: 6px 12px;\r\n  border-radius: 20px;\r\n  font-weight: 500;\r\n}\r\n\r\n.status-badge.bg-success {\r\n  background-color: #28a745 !important;\r\n}\r\n\r\n.status-badge.bg-secondary {\r\n  background-color: #6c757d !important;\r\n}\r\n\r\n.create-button {\r\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\r\n  border: none;\r\n  padding: 12px 24px;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 2px 10px rgba(40, 167, 69, 0.3);\r\n}\r\n\r\n.create-button:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 20px rgba(40, 167, 69, 0.4);\r\n  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);\r\n}\r\n\r\n.modal-content {\r\n  border-radius: 15px;\r\n  border: none;\r\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.modal-header {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  border-radius: 15px 15px 0 0;\r\n  border: none;\r\n}\r\n\r\n.modal-header .btn-close {\r\n  filter: invert(1);\r\n}\r\n\r\n.modal-title {\r\n  font-weight: 600;\r\n}\r\n\r\n.form-label {\r\n  font-weight: 600;\r\n  color: #495057;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.form-control {\r\n  border-radius: 8px;\r\n  border: 2px solid #e9ecef;\r\n  padding: 12px 16px;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.form-control:focus {\r\n  border-color: #667eea;\r\n  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);\r\n}\r\n\r\n.form-switch {\r\n  padding-left: 2.5em;\r\n}\r\n\r\n.form-switch .form-check-input {\r\n  width: 3em;\r\n  height: 1.5em;\r\n  margin-left: -2.5em;\r\n  background-color: #e9ecef;\r\n  border: none;\r\n  border-radius: 1em;\r\n}\r\n\r\n.form-switch .form-check-input:checked {\r\n  background-color: #28a745;\r\n}\r\n\r\n.form-switch .form-check-input:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\r\n}\r\n\r\n.modal-footer {\r\n  border-top: 1px solid #e9ecef;\r\n  padding: 20px;\r\n}\r\n\r\n.modal-footer .btn {\r\n  padding: 10px 24px;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n}\r\n\r\n.delete-alert {\r\n  border-radius: 10px;\r\n  border: none;\r\n}\r\n\r\n.delete-alert .alert-warning {\r\n  background-color: #fff3cd;\r\n  color: #856404;\r\n  border: 1px solid #ffeaa7;\r\n}\r\n\r\n.empty-state {\r\n  text-align: center;\r\n  padding: 40px 20px;\r\n  color: #6c757d;\r\n}\r\n\r\n.empty-state .empty-icon {\r\n  font-size: 3rem;\r\n  margin-bottom: 20px;\r\n  opacity: 0.5;\r\n}\r\n\r\n.loading-spinner {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 300px;\r\n}\r\n\r\n.loading-spinner .spinner-border {\r\n  width: 3rem;\r\n  height: 3rem;\r\n  color: #667eea;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n  .tipos-header {\r\n    padding: 20px;\r\n    text-align: center;\r\n  }\r\n\r\n  .tipos-header h2 {\r\n    font-size: 1.8rem;\r\n  }\r\n\r\n  .category-buttons {\r\n    flex-direction: column;\r\n    gap: 8px;\r\n  }\r\n\r\n  .category-button {\r\n    min-width: 100%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .action-buttons {\r\n    flex-direction: column;\r\n    gap: 4px;\r\n  }\r\n\r\n  .action-buttons .btn {\r\n    min-width: 32px;\r\n    height: 32px;\r\n  }\r\n\r\n  .tipos-table .table thead th,\r\n  .tipos-table .table tbody td {\r\n    padding: 10px 8px;\r\n    font-size: 0.85rem;\r\n  }\r\n}\r\n\r\n/* Animaciones */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.tipos-container {\r\n  animation: fadeIn 0.5s ease-out;\r\n}\r\n\r\n.tipos-table {\r\n  animation: fadeIn 0.6s ease-out;\r\n}\r\n\r\n/* Estilos para el estado vacío */\r\n.empty-state-container {\r\n  background: white;\r\n  border-radius: 10px;\r\n  padding: 40px;\r\n  text-align: center;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.empty-state-container .empty-icon {\r\n  font-size: 4rem;\r\n  color: #dee2e6;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.empty-state-container h4 {\r\n  color: #6c757d;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.empty-state-container p {\r\n  color: #adb5bd;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n/* Estilos para el texto \"Activo\" en el modal de edición */\r\n.modal .form-check label {\r\n  padding-left: 20px !important;\r\n  padding-top: 3px !important;\r\n}\r\n\r\n/* Estilos para el contenedor de búsqueda integrado */\r\n.search-input-container {\r\n  width: 100%;\r\n  /* Occupies full width */\r\n  padding-top: 20px;\r\n  /* Added padding top for spacing */\r\n}\r\n\r\n.search-input-container .input-group {\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  width: 100%;\r\n  /* The input group also occupies full width */\r\n}\r\n\r\n.search-input-container .form-control {\r\n  border-radius: 0 8px 8px 0;\r\n  border-left: none;\r\n}\r\n\r\n.search-input-container .input-group-text {\r\n  background: white;\r\n  border-right: none;\r\n  border-radius: 8px 0 0 8px;\r\n  color: #6c757d;\r\n}\r\n\r\n/* Estilos para la columna de acciones */\r\n.tipos-table th:last-child,\r\n.tipos-table td:last-child {\r\n  width: 80px;\r\n  /* Reducir el ancho de la columna de acciones */\r\n  min-width: 80px;\r\n  /* Ancho mínimo para evitar que se comprima demasiado */\r\n  max-width: 80px;\r\n  /* Ancho máximo para mantener consistencia */\r\n  text-align: center;\r\n  /* Centrar el contenido de la columna */\r\n}\r\n\r\n/* Ajustar el ancho de las otras columnas */\r\n.tipos-table th:first-child,\r\n.tipos-table td:first-child {\r\n  width: 60%;\r\n  /* La columna de nombre ocupa más espacio */\r\n}\r\n\r\n.tipos-table th:nth-child(2),\r\n.tipos-table td:nth-child(2) {\r\n  width: 30%;\r\n  /* La columna de estado ocupa menos espacio */\r\n}\r\n\r\n/* Estilos específicos por clase para mayor control */\r\n.tipos-data-table .nombre-column {\r\n  width: 60%;\r\n  min-width: 200px;\r\n}\r\n\r\n.tipos-data-table .estado-column {\r\n  width: 30%;\r\n  min-width: 120px;\r\n}\r\n\r\n.tipos-data-table .acciones-column {\r\n  width: 80px;\r\n  min-width: 80px;\r\n  max-width: 80px;\r\n  text-align: center;\r\n}\r\n\r\n/* Asegurar que los botones de acción no se desborden */\r\n.tipos-data-table .action-buttons {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n\r\n.tipos-data-table .action-buttons .btn {\r\n  padding: 0.25rem 0.5rem;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n/* Ajustes aislados para la categoría \"Documentos\":\r\n   se desactivan anchos rígidos y se compacta la tabla para evitar scroll horizontal. */\r\n.tipos-data-table-documentos .nombre-column,\r\n.tipos-data-table-documentos .estado-column,\r\n.tipos-data-table-documentos .acciones-column,\r\n.tipos-data-table-documentos th,\r\n.tipos-data-table-documentos td {\r\n  width: auto !important;\r\n  min-width: 0 !important;\r\n  max-width: none !important;\r\n}\r\n\r\n.tipos-data-table-documentos thead th,\r\n.tipos-data-table-documentos tbody td {\r\n  padding: 10px 8px;\r\n}\r\n\r\n.tipos-data-table-documentos .nombre-column,\r\n.tipos-data-table-documentos td:first-child {\r\n  white-space: normal;\r\n}\r\n\r\n/* Estilos para el modal */\r\n.modal .form-check label {\r\n  padding-left: 20px !important;\r\n  padding-top: 3px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
